import { createServerFn } from "@tanstack/react-start";
import { getCookie } from "@tanstack/react-start/server";
import { Option, Schema } from "effect";

type SortPreference = "popularity" | "alphabetical";

const SortPreferenceSchema = Schema.Literal(
  "popularity",
  "alphabetical"
);

const SortSectionSchema = Schema.Literal(
  "project",
  "integrations",
  "organization",
  "dashboard",
  "platform-docs"
);

const SORT_PREFERENCE_COOKIE_PREFIX = "sort-preference-";

const decodeSortSection = Schema.decodeUnknownSync(
  SortSectionSchema
);
const decodeSortPreference = Schema.decodeUnknownOption(
  SortPreferenceSchema
);

export const getSortPreferenceServerFn = createServerFn({
  method: "GET",
})
  .inputValidator((data: unknown) => {
    return decodeSortSection(data);
  })
  .handler(({ data: section }) => {
    const cookieName = `${SORT_PREFERENCE_COOKIE_PREFIX}${section}`;
    const cookieValue = getCookie(cookieName);

    // Validate cookie value or return default
    if (cookieValue) {
      return Option.getOrElse(
        decodeSortPreference(cookieValue),
        () => "popularity" as SortPreference
      );
    }

    return "popularity" as SortPreference;
  });
